import actions from '../actions/auth';
import base from './base';

const reducer = base(actions.types);
export default reducer;